module.exports = __webpack_public_path__ + "static/media/Mobile.9fd76ae6.svg";